export default {
  state: {
    menu: true,
    drag: false,
    infoModal: {
      show: false,
      variant: undefined,
      message: undefined,
      action: undefined,
    },
  },
  getters: {
    menuDrawer: state => state.menu,
    isDragging: state => state.drag,
  },
  mutations: {
    SET_DRAG(state, payload) {
      state.drag = payload;
    },
    CLOSE_MENU(state) {
      state.menu = true;
    },
    TOGGLE_MENU(state) {
      state.menu = !state.menu;
    },
    SET_INFO_MODAL(state, {
      show = true,
      variant,
      message,
      action,
    }) {
      state.infoModal = {
        show,
        variant,
        message,
        action,
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/app.js